import React, { useState } from 'react';
import { Box } from '@mui/material';
import ArrowDropDownRounded from '@src/assets/icons/ArrowDropDownRounded.svg';
import CustomSelect from '@src/components/CustomSelect';
import { useClickOutside } from '@src/hooks/useClickOutSide';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { StyledSelectSearch } from './index.style';

const SelectSearch = ({
  options,
  value,
  onChange,
  placeholder,
  label,
  error,
  helperText,
  disabled,
  searchFields,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownEl = useClickOutside(() => {
    setShowDropdown(false);
  });

  const changeHandler = (option) => {
    onChange(option);
  };

  const getOption = (option) => options?.find((item) => item.value === option);

  return (
    <StyledSelectSearch ref={dropdownEl}>
      <Box>
        <Typography
          className="input-label"
          variant="body-14-medium"
          color={COLOR.darkGray}
        >
          {label}
        </Typography>
        <Box
          onClick={() => !disabled && setShowDropdown(!showDropdown)}
          className={`select-btn-select-search ${
            error ? 'select-search-error' : ''
          } ${disabled ? 'select-btn-select-search-disabled' : ''}`}
        >
          <Typography
            variant="body-14-regular"
            className="select-btn-select-search-text"
            color={
              disabled || !value ? COLOR.label2[48] : COLOR.descriptionGray
            }
          >
            {value || placeholder}
          </Typography>
          {!disabled && <img src={ArrowDropDownRounded} alt="" />}
        </Box>
        {error && (
          <Typography
            variant="body-14-regular"
            color={COLOR.functionalRed.default}
          >
            {helperText}
          </Typography>
        )}
      </Box>
      {showDropdown && (
        <div className="select-custom">
          <CustomSelect
            showDropdown={showDropdown}
            onSetShowDropdown={setShowDropdown}
            data={options}
            currentOption={getOption(value)}
            onChange={changeHandler}
            searchFields={searchFields}
          />
        </div>
      )}
    </StyledSelectSearch>
  );
};

export default SelectSearch;
